import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import FormHeader from "../common/FormHeader";
import "./formTitle.css";
import "./themePlaceholder.css";

function PPMReport() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    siteName: "",
    address: "",
    postcode: "",
    audioPA: {
      commend: false,
      adpro: false,
      heitel: false,
      paLocal: "",
      paAudible: "",
      paRepairs: ""
    },
    comms: {
      routerLocked: ""
    },
    access: {
      breakglassesIntact: "",
      backupChecked: "",
      backupReplaced: "",
      gatesIntegrated: "",
      accessRepairs: ""
    },
    safety: {
      localAccess: "",
      supervision: "",
      heightEquip: "",
      confinedSpace: ""
    },
    control: {
      readersWorking: "",
      firmware: "",
      pushToExit: ""
    },
    cctv: {
      heitel: false,
      adpro: false,
      camerasClean: "",
      ptzFunction: "",
      presetsSet: "",
      masking: "",
      causeEffect: ""
    },
    gates: {
      repairs: ""
    },
    intercom: {
      operates: "",
      repairs: ""
    },
    intruder: {
      firmware: ""
    },
    generalObs: {
      containment: "",
      wallBrackets: "",
      columnFixings: "",
      winches: "",
      vandalism: ""
    },
    pids: {
      tested: "",
      repairs: ""
    },
    electricFence: {
      voltage: "",
      setUnset: "",
      repairs: ""
    },
    ups: {
      working: "",
      repairs: ""
    }
  });
  const [extraFields, setExtraFields] = useState({
    description: "",
    checkedBy: "",
    timeOn: "",
    timeOff: "",
    date: "",
    signature: ""
  });

  const sigCanvasRef = useRef(null);

  const clearSignature = () => {
    sigCanvasRef.current.clear();
    setExtraFields(prev => ({
      ...prev,
      signature: ""
    }));
  };

  const saveSignature = () => {
    if (!sigCanvasRef.current.isEmpty()) {
      setExtraFields(prev => ({
        ...prev,
        signature: sigCanvasRef.current.getTrimmedCanvas().toDataURL("image/png")
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("PPM Report Submitted!");
    navigate(-1);
  };

  // For top-level fields (siteName, address, postcode, etc.)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // For nested fields (e.g. form.safety.localAccess)
  const handleNestedChange = (section, key, value) => {
    setForm(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: value
      }
    }));
  };

  // For extraFields (description, checkedBy, etc.)
  const handleExtraChange = (e) => {
    const { name, value } = e.target;
    setExtraFields(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // For CCTV checkboxes/radios (if you have a special handler)
  const handleCCTVChange = (key, value) => {
    setForm(prev => ({
      ...prev,
      cctv: {
        ...prev.cctv,
        [key]: value
      }
    }));
  };

  return (
    <div style={{ height: "100vh", overflowY: "auto", background: "#f5f7fa" }}>
      <FormHeader />
      <div className="container py-4">
       
        <div className="card shadow-sm rounded-4 p-4">
          <h2
            className="text-center text-white py-2 mb-4 rounded"
            style={{
              backgroundColor: "#8b1634",
              letterSpacing: "1px",
              fontSize: "1.8rem"
            }}
          >
            PPM Report Form
          </h2>
          <form onSubmit={handleSubmit}>
            {/* Site Info */}
            <div className="row g-4 mb-3">
              <div className="col-md-4">
                <input
                  type="text"
                  name="siteName"
                  value={form.siteName}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Full Site Name"
                  required
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "2px solid #8b1634",
                    fontSize: "1.08rem",
                    paddingLeft: "18px"
                  }}
                  onFocus={e => (e.target.style.borderColor = "#8b1634")}
                  onBlur={e => (e.target.style.borderColor = "#8b1634")}
                />
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  name="address"
                  value={form.address}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Address"
                  required
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "2px solid #8b1634",
                    fontSize: "1.08rem",
                    paddingLeft: "18px"
                  }}
                  onFocus={e => (e.target.style.borderColor = "#8b1634")}
                  onBlur={e => (e.target.style.borderColor = "#8b1634")}
                />
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  name="postcode"
                  value={form.postcode}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Postcode"
                  required
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "2px solid #8b1634",
                    fontSize: "1.08rem",
                    paddingLeft: "18px"
                  }}
                  onFocus={e => (e.target.style.borderColor = "#8b1634")}
                  onBlur={e => (e.target.style.borderColor = "#8b1634")}
                />
              </div>
            </div>

            {/* Access / Safety Requirements */}
            <div className="mb-4 p-3 border border-2 rounded-4 bg-light-subtle">
              <div className="fw-bold mb-3" style={{ color: "#8b1634", fontSize: "1.1rem" }}>
                Access / Safety Requirements
              </div>
              <div className="mb-2">Are there any areas that have local access requirements i.e. shared NG Sites</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="localAccess"
                      checked={form.safety.localAccess === opt}
                      onChange={() => handleNestedChange("safety", "localAccess", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Are there any areas that require LOA's / Supervision</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="supervision"
                      checked={form.safety.supervision === opt}
                      onChange={() => handleNestedChange("safety", "supervision", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Are there any requirements for working at height equipment: Mobile Towers, Podiums, MEWPS etc.</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="heightEquip"
                      checked={form.safety.heightEquip === opt}
                      onChange={() => handleNestedChange("safety", "heightEquip", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Are there any confined space areas that require the use of a Gas Monitor</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="confinedSpace"
                      checked={form.safety.confinedSpace === opt}
                      onChange={() => handleNestedChange("safety", "confinedSpace", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
            </div>

            {/* Access Control */}
            <div className="mb-4 p-3 border border-2 rounded-4 bg-light-subtle">
              <div className="fw-bold mb-3" style={{ color: "#8b1634", fontSize: "1.1rem" }}>
                Access Control
              </div>
              <div className="mb-2">Are readers working with UKPN access card (inc. PIN code if fitted) - Check with SMC to ensure events are being received</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="readersWorking"
                      checked={form.control.readersWorking === opt}
                      onChange={() => handleNestedChange("control", "readersWorking", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Is ACU Firmware up-to-date</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="firmware"
                      checked={form.control.firmware === opt}
                      onChange={() => handleNestedChange("control", "firmware", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Are all Push to Exit's working</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="pushToExit"
                      checked={form.control.pushToExit === opt}
                      onChange={() => handleNestedChange("control", "pushToExit", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Are all Breakglasses Intact</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="breakglassesIntact"
                      checked={form.access.breakglassesIntact === opt}
                      onChange={() => handleNestedChange("access", "breakglassesIntact", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Have the backup Batteries been Checked</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="backupChecked"
                      checked={form.access.backupChecked === opt}
                      onChange={() => handleNestedChange("access", "backupChecked", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Have the backup Batteries been Replaced (where required)</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="backupReplaced"
                      checked={form.access.backupReplaced === opt}
                      onChange={() => handleNestedChange("access", "backupReplaced", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Are gates fully integrated with system</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="gatesIntegrated"
                      checked={form.access.gatesIntegrated === opt}
                      onChange={() => handleNestedChange("access", "gatesIntegrated", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Does the Access system require repairs or improvements (if so, state at end of document)</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="accessRepairs"
                      checked={form.access.accessRepairs === opt}
                      onChange={() => handleNestedChange("access", "accessRepairs", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
            </div>

            {/* Audio PA */}
            <div className="mb-4 p-3 border border-2 rounded-4 bg-light-subtle">
              <div className="fw-bold mb-3" style={{ color: "#8b1634", fontSize: "1.1rem" }}>
                Audio PA
              </div>
              <div className="mb-3 d-flex gap-4">
                <label style={{ color: "#8b1634", fontWeight: 500 }}>
                  <input
                    type="checkbox"
                    checked={form.audioPA.commend}
                    onChange={e => handleNestedChange("audioPA", "commend", e.target.checked)}
                    style={{ accentColor: "#8b1634", marginRight: 6 }}
                  /> Commend
                </label>
                <label style={{ color: "#8b1634", fontWeight: 500 }}>
                  <input
                    type="checkbox"
                    checked={form.audioPA.adpro}
                    onChange={e => handleNestedChange("audioPA", "adpro", e.target.checked)}
                    style={{ accentColor: "#8b1634", marginRight: 6 }}
                  /> ADPRO
                </label>
                <label style={{ color: "#8b1634", fontWeight: 500 }}>
                  <input
                    type="checkbox"
                    checked={form.audioPA.heitel}
                    onChange={e => handleNestedChange("audioPA", "heitel", e.target.checked)}
                    style={{ accentColor: "#8b1634", marginRight: 6 }}
                  /> Heitel
                </label>
              </div>
              <div className="mb-2">Does PA work locally on site - Test with SMC</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="paLocal"
                      checked={form.audioPA.paLocal === opt}
                      onChange={() => handleNestedChange("audioPA", "paLocal", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Is PA audible and clear</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="paAudible"
                      checked={form.audioPA.paAudible === opt}
                      onChange={() => handleNestedChange("audioPA", "paAudible", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Does the PA system require repairs or improvements (if so, state at end of document)</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="paRepairs"
                      checked={form.audioPA.paRepairs === opt}
                      onChange={() => handleNestedChange("audioPA", "paRepairs", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
            </div>

            {/* Comms */}
            <div className="mb-4 p-3 border border-2 rounded-4 bg-light-subtle">
              <div className="fw-bold mb-3" style={{ color: "#8b1634", fontSize: "1.1rem" }}>
                Comms
              </div>
              <div className="mb-2">
                If a Router has been fitted, has Wi-Fi been locked down to prevent unauthorised access.
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="routerLocked"
                      checked={form.comms.routerLocked === opt}
                      onChange={() => handleNestedChange("comms", "routerLocked", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
            </div>

            {/* CCTV Section */}
            <div className="mb-4 p-3 border border-2 rounded-4 bg-light-subtle">
              <div className="fw-bold mb-3" style={{ color: "#8b1634", fontSize: "1.1rem" }}>
                CCTV
              </div>
              <div className="mb-3 d-flex gap-4">
                <label style={{ color: "#8b1634", fontWeight: 500 }}>
                  <input
                    type="checkbox"
                    checked={form.cctv.heitel}
                    onChange={e => handleCCTVChange("heitel", e.target.checked)}
                    style={{ accentColor: "#8b1634", marginRight: 6 }}
                  /> Heitel
                </label>
                <label style={{ color: "#8b1634", fontWeight: 500 }}>
                  <input
                    type="checkbox"
                    checked={form.cctv.adpro}
                    onChange={e => handleCCTVChange("adpro", e.target.checked)}
                    style={{ accentColor: "#8b1634", marginRight: 6 }}
                  /> ADPRO
                </label>
              </div>
              <div className="mb-2">Are Cameras Clean and in focus</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="camerasClean"
                      checked={form.cctv.camerasClean === opt}
                      onChange={() => handleCCTVChange("camerasClean", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Are PTZ cameras and telemetry functioning correctly</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="ptzFunction"
                      checked={form.cctv.ptzFunction === opt}
                      onChange={() => handleCCTVChange("ptzFunction", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Have all Presets and home positions been set correctly (check against commissioning documentation)</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="presetsSet"
                      checked={form.cctv.presetsSet === opt}
                      onChange={() => handleCCTVChange("presetsSet", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Has masking been applied to protect local residents privacy</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="masking"
                      checked={form.cctv.masking === opt}
                      onChange={() => handleCCTVChange("masking", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Is Cause and Effect Detection working - conduct a walk test to confirm maximum detection coverage, check with SMC</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="causeEffect"
                      checked={form.cctv.causeEffect === opt}
                      onChange={() => handleCCTVChange("causeEffect", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Is DVR/NVR Firmware up-to-date</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="dvrFirmware"
                      checked={form.cctv?.dvrFirmware === opt}
                      onChange={() => handleCCTVChange("dvrFirmware", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Are cameras set to correct Frames per second (check against commissioning documentation)</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="fpsCorrect"
                      checked={form.cctv?.fpsCorrect === opt}
                      onChange={() => handleCCTVChange("fpsCorrect", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Can recordings be accessed</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="recordingsAccessed"
                      checked={form.cctv?.recordingsAccessed === opt}
                      onChange={() => handleCCTVChange("recordingsAccessed", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">Does the CCTV system require repairs or improvements (if so, state at end of document)</div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="cctvRepairs"
                      checked={form.cctv?.cctvRepairs === opt}
                      onChange={() => handleCCTVChange("cctvRepairs", opt)}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
            </div>

            {/* Gates / Barriers shutters */}
            <div className="mb-4 p-3 border border-2 rounded-4 bg-light-subtle">
              <div className="fw-bold mb-3" style={{ color: "#8b1634", fontSize: "1.1rem" }}>
                Gates / Barriers shutters
              </div>
              <div className="mb-2">
                Do the Gates require repairs or improvements (if so, state at end of document)
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="gatesRepairs"
                      checked={form.gates.repairs === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        gates: { ...prev.gates, repairs: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
            </div>

            {/* Intercom (Voice / Video) */}
            <div className="mb-4 p-3 border border-2 rounded-4 bg-light-subtle">
              <div className="fw-bold mb-3" style={{ color: "#8b1634", fontSize: "1.1rem" }}>
                Intercom (Voice / Video)
              </div>
              <div className="mb-2">
                Does the system operate correctly - check with SMC
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="intercomOperates"
                      checked={form.intercom.operates === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        intercom: { ...prev.intercom, operates: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Does the Intercom system require repairs or improvements (if so, state at end of document)
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="intercomRepairs"
                      checked={form.intercom.repairs === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        intercom: { ...prev.intercom, repairs: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
            </div>

            {/* Intruder Alarm */}
            <div className="mb-4 p-3 border border-2 rounded-4 bg-light-subtle">
              <div className="fw-bold mb-3" style={{ color: "#8b1634", fontSize: "1.1rem" }}>
                Intruder Alarm
              </div>
              <div className="mb-2">
                Is Panel Firmware up-to-date
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="intruderFirmware"
                      checked={form.intruder.firmware === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        intruder: { ...prev.intruder, firmware: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Have the Backup Batteries been Checked
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="intruderBackupChecked"
                      checked={form.intruder.backupChecked === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        intruder: { ...prev.intruder, backupChecked: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Have the Backup Batteries been Replaced (where required)
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="intruderBackupReplaced"
                      checked={form.intruder.backupReplaced === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        intruder: { ...prev.intruder, backupReplaced: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                How is the system set (Card, Cyberkey, PIN)
              </div>
              <div className="mb-3 d-flex align-items-center gap-3">
                <input
                  type="text"
                  name="intruderSystemSet"
                  value={form.intruder.systemSet || ""}
                  onChange={e => setForm(prev => ({
                    ...prev,
                    intruder: { ...prev.intruder, systemSet: e.target.value }
                  }))}
                  className="form-control"
                  placeholder="Enter value"
                  style={{ maxWidth: 250 }}
                />
                <label style={{ color: "#8b1634", fontWeight: 500 }}>
                  <input
                    type="checkbox"
                    checked={form.intruder.systemSetNA || false}
                    onChange={e => setForm(prev => ({
                      ...prev,
                      intruder: { ...prev.intruder, systemSetNA: e.target.checked }
                    }))}
                    style={{ accentColor: "#8b1634", marginLeft: 8, marginRight: 6 }}
                  /> N/A
                </label>
              </div>
              <div className="mb-2">
                Is there a Timed Schedule setup on the system (Do logs confirm this?)
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="intruderTimedSchedule"
                      checked={form.intruder.timedSchedule === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        intruder: { ...prev.intruder, timedSchedule: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Are External Bells connected or silenced
              </div>
              <div className="mb-3 d-flex align-items-center gap-3">
                <input
                  type="text"
                  name="intruderExternalBells"
                  value={form.intruder.externalBells || ""}
                  onChange={e => setForm(prev => ({
                    ...prev,
                    intruder: { ...prev.intruder, externalBells: e.target.value }
                  }))}
                  className="form-control"
                  placeholder="Enter value"
                  style={{ maxWidth: 250 }}
                />
                <label style={{ color: "#8b1634", fontWeight: 500 }}>
                  <input
                    type="checkbox"
                    checked={form.intruder.externalBellsNA || false}
                    onChange={e => setForm(prev => ({
                      ...prev,
                      intruder: { ...prev.intruder, externalBellsNA: e.target.checked }
                    }))}
                    style={{ accentColor: "#8b1634", marginLeft: 8, marginRight: 6 }}
                  /> N/A
                </label>
              </div>
              <div className="mb-2">
                Are Audible Panel Alarms connected or silenced
              </div>
              <div className="mb-3 d-flex align-items-center gap-3">
                <input
                  type="text"
                  name="intruderPanelAlarms"
                  value={form.intruder.panelAlarms || ""}
                  onChange={e => setForm(prev => ({
                    ...prev,
                    intruder: { ...prev.intruder, panelAlarms: e.target.value }
                  }))}
                  className="form-control"
                  placeholder="Enter value"
                  style={{ maxWidth: 250 }}
                />
                <label style={{ color: "#8b1634", fontWeight: 500 }}>
                  <input
                    type="checkbox"
                    checked={form.intruder.panelAlarmsNA || false}
                    onChange={e => setForm(prev => ({
                      ...prev,
                      intruder: { ...prev.intruder, panelAlarmsNA: e.target.checked }
                    }))}
                    style={{ accentColor: "#8b1634", marginLeft: 8, marginRight: 6 }}
                  /> N/A
                </label>
              </div>
              <div className="mb-2">
                Have Door Contacts been Checked
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="intruderDoorContacts"
                      checked={form.intruder.doorContacts === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        intruder: { ...prev.intruder, doorContacts: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Have PIR's been Checked
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="intruderPIRs"
                      checked={form.intruder.pirs === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        intruder: { ...prev.intruder, pirs: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                is alarm set to default protocol (currently TCP)
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="intruderDefaultProtocol"
                      checked={form.intruder.defaultProtocol === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        intruder: { ...prev.intruder, defaultProtocol: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Does the Intruder system require repairs or improvements (if so, state at end of document)
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="intruderRepairs"
                      checked={form.intruder.repairs === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        intruder: { ...prev.intruder, repairs: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
            </div>

            {/* Security LED Lighting */}
            <div className="mb-4 p-3 border border-2 rounded-4 bg-light-subtle">
              <div className="fw-bold mb-3" style={{ color: "#8b1634", fontSize: "1.1rem" }}>
                Security LED Lighting
              </div>
              <div className="mb-2">
                Are lights in good working order
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="ledWorking"
                      checked={form.led?.working === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        led: { ...prev.led, working: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                If fitted, has the override Switch been tested
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="ledOverride"
                      checked={form.led?.override === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        led: { ...prev.led, override: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Is the photocell working
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="ledPhotocell"
                      checked={form.led?.photocell === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        led: { ...prev.led, photocell: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Does the LED Light system require repairs or improvements (if so, state at end of document)
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="ledRepairs"
                      checked={form.led?.repairs === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        led: { ...prev.led, repairs: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
            </div>

            {/* PIDS Fence Detection */}
            <div className="mb-4 p-3 border border-2 rounded-4 bg-light-subtle">
              <div className="fw-bold mb-3" style={{ color: "#8b1634", fontSize: "1.1rem" }}>
                PIDS Fence Detection
              </div>
              <div className="mb-2">
                Have the Fence mounted PIDS been tested physically - Test with SMC
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="pidsTested"
                      checked={form.pids?.tested === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        pids: { ...prev.pids, tested: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Do PIDS require repairs or improvements (if so, state at end of document)
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="pidsRepairs"
                      checked={form.pids?.repairs === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        pids: { ...prev.pids, repairs: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
            </div>

            {/* Electric Fence Detection */}
            <div className="mb-4 p-3 border border-2 rounded-4 bg-light-subtle">
              <div className="fw-bold mb-3" style={{ color: "#8b1634", fontSize: "1.1rem" }}>
                Electric Fence Detection
              </div>
              <div className="mb-2">
                Has the Fence been voltage tested
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="electricFenceVoltage"
                      checked={form.electricFence?.voltage === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        electricFence: { ...prev.electricFence, voltage: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Has set/unset function been tested
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="electricFenceSetUnset"
                      checked={form.electricFence?.setUnset === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        electricFence: { ...prev.electricFence, setUnset: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Does the Electric Fence require repairs or improvements (if so, state at end of document)
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="electricFenceRepairs"
                      checked={form.electricFence?.repairs === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        electricFence: { ...prev.electricFence, repairs: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
            </div>

            {/* Uninterrupted Power Supply */}
            <div className="mb-4 p-3 border border-2 rounded-4 bg-light-subtle">
              <div className="fw-bold mb-3" style={{ color: "#8b1634", fontSize: "1.1rem" }}>
                Uninterrupted Power Supply
              </div>
              <div className="mb-2">
                If fitted, is the UPS working
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="upsWorking"
                      checked={form.ups?.working === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        ups: { ...prev.ups, working: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Does the UPS require repairs or improvements (if so, state at end of document)
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="upsRepairs"
                      checked={form.ups?.repairs === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        ups: { ...prev.ups, repairs: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
            </div>

            {/* General Observations */}
            <div className="mb-4 p-3 border border-2 rounded-4 bg-light-subtle">
              <div className="fw-bold mb-3" style={{ color: "#8b1634", fontSize: "1.1rem" }}>
                General Observations
              </div>
              <div className="mb-2">
                Is the containment system in good condition?
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="containment"
                      checked={form.generalObs.containment === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        generalObs: { ...prev.generalObs, containment: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Are the wall pole brackets in good condition and secure?
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="wallBrackets"
                      checked={form.generalObs.wallBrackets === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        generalObs: { ...prev.generalObs, wallBrackets: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Are the column fixings in good condition and secure?
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="columnFixings"
                      checked={form.generalObs.columnFixings === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        generalObs: { ...prev.generalObs, columnFixings: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Have winches been serviced and are they still in date
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="winches"
                      checked={form.generalObs.winches === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        generalObs: { ...prev.generalObs, winches: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
              <div className="mb-2">
                Is there any signs of vandalism or tampering with any external equipment?
              </div>
              <div className="mb-3 d-flex gap-4">
                {["YES", "NO", "N/A"].map(opt => (
                  <label key={opt} style={{ color: "#8b1634", fontWeight: 500 }}>
                    <input
                      type="radio"
                      name="vandalism"
                      checked={form.generalObs.vandalism === opt}
                      onChange={() => setForm(prev => ({
                        ...prev,
                        generalObs: { ...prev.generalObs, vandalism: opt }
                      }))}
                      style={{ accentColor: "#8b1634", marginRight: 6 }}
                    /> {opt}
                  </label>
                ))}
              </div>
            </div>

            {/* Extra Fields */}
            <div className="mb-4">
              <div className="row mb-3">
                <div className="col-12 col-md-6 mb-3 mb-md-0">
                  <textarea
                    name="description"
                    value={extraFields.description}
                    onChange={handleExtraChange}
                    className="form-control"
                    placeholder="Description of Works Undertaken/Required"
                    rows={3}
                    style={{ border: "2px solid #8b1634", borderRadius: "10px" }}
                    required
                  />
                </div>
                <div className="col-12 col-md-6">
                  <input
                    type="text"
                    name="checkedBy"
                    value={extraFields.checkedBy}
                    onChange={handleExtraChange}
                    className="form-control"
                    placeholder="Checked by"
                    style={{ border: "2px solid #8b1634", borderRadius: "10px" }}
                    required
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-12 col-md-4 mb-3 mb-md-0">
                  <input
                    type="text"
                    name="timeOn"
                    value={extraFields.timeOn}
                    onChange={handleExtraChange}
                    className="form-control"
                    placeholder="Time On"
                    required
                  />
                </div>
                <div className="col-12 col-md-4 mb-3 mb-md-0">
                  <input
                    type="text"
                    name="timeOff"
                    value={extraFields.timeOff}
                    onChange={handleExtraChange}
                    className="form-control"
                    placeholder="Time Off"
                    required
                  />
                </div>
                <div className="col-12 col-md-4">
                  <input
                    type="date"
                    name="date"
                    value={extraFields.date}
                    onChange={handleExtraChange}
                    className="form-control"
                    required
                  />
                </div>
              </div>
              <div className="mb-2 fw-bold" style={{ color: "#8b1634" }}>Signature</div>
              <div className="row">
                <div className="col-12 col-md-4 mb-3">
                  <div style={{
                    width: '100%',
                    border: '2px solid #8b1634',
                    borderRadius: '18px',
                    background: '#e9cfd6',
                    padding: '0.5rem',
                    textAlign: 'left',
                    position: 'relative',
                    minHeight: '120px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                  }}>
                    <SignatureCanvas
                      ref={sigCanvasRef}
                      penColor="#8b1634"
                      backgroundColor="#e9cfd6"
                      clearOnResize={false}
                      velocityFilterWeight={0.7}
                      minWidth={1}
                      maxWidth={2.5}
                      dotSize={1.5}
                      throttle={16}
                      canvasProps={{
                        width: window.innerWidth > 600 ? 350 : 300,
                        height: 100,
                        style: {
                          width: '100%',
                          height: '100px',
                          border: 'none',
                          borderRadius: '18px',
                          background: '#e9cfd6',
                          display: 'block',
                          touchAction: 'none' // ensures touch works on mobile
                        }
                      }}
                      onEnd={saveSignature}
                    />
                    <div style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginTop: '4px'
                    }}>
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm rounded-pill px-3"
                        style={{
                          background: 'transparent',
                          color: '#8b1634',
                          borderColor: '#8b1634'
                        }}
                        onClick={clearSignature}>
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
            
              </div>
            </div>

            {/* Submit Button */}
            <div className="row">
              <div className="col-12 d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-lg text-white fw-bold px-5 py-2 mt-4"
                  style={{
                    backgroundColor: "#8b1634",
                    borderRadius: "30px",
                    boxShadow: "0 4px 12px rgba(139,22,52,0.3)"
                  }}
                >
                  Submit Report
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PPMReport;
